<template>
    <div class="goods-message">
        <template v-for="message in returnGoodsType">
            <p :class="message.class">{{message.content}}</p>
        </template>
    </div>
</template>
<script>
export default {
    name: 'goods-message',
    props: {
        goods:{
            type: Object,
            required: true
        }
    },
    data(){
        return {
            item:{}
        }
    },
    watch:{
        goods:{
            handler(newVal){
                this.item = newVal
            },
            deep: true
        }
    },
    mounted(){
        this.item = this.goods
    },
    computed:{
        returnGoodsType(){
            // 根据商品类型返回不同的商品类型,只返回一个活动类型，换购不改价格不涉及判断
            const typeMap = [
                {
                    id: 'seckill',
                    condition: () => this.item.promotion_label === 'seckill',
                    funKey: this.returnSeckillMessage
                },
                {
                    id: 'discount',
                    condition: () => this.item.promotion_label === 'discount',
                    funKey: this.returnDiscountMessage
                },
                {
                    id: 'wholesale',
                    condition: () => this.item.promotion_label === 'wholesale',
                    funKey: this.returnWholesaleMessage
                }
            ];
            
            const foundType = typeMap.find(item => item.condition());
            return foundType ? foundType.funKey : [];
        },
        
        // 秒杀商品信息提示判断
        returnSeckillMessage(){
            const messages = [];
            const { num, goods_min, goods_limit, price, discount_price } = this.item;
            
            // 检查必要参数
            if (num === undefined || goods_min === undefined) {
                return messages;
            }
            
            // 未满足最小购买数量提示
            if (num < goods_min) {
                messages.push(this._createMessage('redText',`提示：当前商品优惠起购数量为${goods_min}，小于${goods_min}将不享受优惠`));
                return messages;
            }
            
            // 无限购限制提示
            if (goods_limit == 0) {
                messages.push(this._createMessage('greenText', `提示：当前商品优惠不限制购买数量`));
                return messages;
            }
            
            // 有限购限制且已满足最小购买数量
            if (num >= goods_min && goods_limit > 0) {
                // 超出限购数量
                if (num > goods_limit) {
                    messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                    
                    messages.push(this._createMessage('redText', `原价：￥${price} x ${num - goods_limit} 秒杀价：￥${discount_price} x ${goods_limit}`));
                } 
                // 未超出限购数量
                else if (num < goods_limit) {
                    messages.push(this._createMessage('redText', `提示：您还可购买${goods_limit - num}，超出部分恢复原价`));
                }
            }
            
            return messages;
        },
        
        // 特价商品信息提示判断
        returnDiscountMessage(){
            const messages = [];
            const { num, price, discount_price } = this.item;
            
            // 检查必要参数
            if (num === undefined || !this.item.promotion_info) {
                return messages;
            }
            
            const { goods_min, goods_limit, num_multiple } = this.item.promotion_info;
            
            // 未满足最小购买数量提示
            if (num < goods_min) {
                messages.push(this._createMessage('redText', `提示：当前商品优惠起购数量为${goods_min}，小于${goods_min}将不享受优惠`));
                return messages;
            }
            
            // 无限购限制提示
            if (goods_limit == 0) {
                messages.push(this._createMessage('greenText', `提示：当前商品优惠不限制购买数量`));
            }
            
            // 倍数购买逻辑
            if (num_multiple > 1 && num >= goods_min) {
                this._handleMultiplePurchase(messages, { num, price, discount_price, goods_min, goods_limit, num_multiple });
            } 
            // 非倍数购买且有限购逻辑
            else if (num >= goods_min && goods_limit > 0 && num_multiple <= 1) {
                this._handleNormalPurchase(messages, { num, price, discount_price, goods_limit });
            }
            
            return messages;
        },
        
        // 阶梯商品信息提示判断
        returnWholesaleMessage(){
            // 待实现
            return [];
        }
    },
    
    methods: {
        // 创建消息对象
        _createMessage(className, content) {
            return {
                class: className,
                content: content
            };
        },
        
        // 处理倍数购买场景
        _handleMultiplePurchase(messages, { num, price, discount_price, goods_limit, num_multiple }) {
            // 倍数购买提示
            messages.push(this._createMessage('redText', `提示：当前特价仅${num_multiple}的倍数可享受，超出按原价计算`));
            
            // 超出限购
            if (goods_limit > 0 && num > goods_limit) {
                messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                
                // 计算有效特价数量
                const quotient = Math.floor(goods_limit / num_multiple) * num_multiple;
                messages.push(this._createMessage('redText', `原价：￥${price} x ${num - quotient} 特价：￥${discount_price} x ${quotient}`));
            } 
            // 未超出限购或无限购限制
            else if (goods_limit == 0 || num <= goods_limit) {
                const remainder = num % num_multiple;
                if (remainder > 0&&num - remainder>0) {
                    messages.push(this._createMessage('redText', `原价：￥${price} x ${remainder} 特价：￥${discount_price} x ${num - remainder}`));
                }
            }
        },
        
        // 处理非倍数购买场景
        _handleNormalPurchase(messages, { num, price, discount_price, goods_limit }) {
            // 超出限购
            if (num > goods_limit) {
                messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                messages.push(this._createMessage('redText', `原价：￥${price} x ${num - goods_limit} 特价：￥${discount_price} x ${goods_limit}`));
            } 
            // 未超出限购
            else if (num < goods_limit) {
                messages.push(this._createMessage('redText', `提示：您还可购买${goods_limit - num}，超出部分恢复原价`));
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.goods-message{
    display: flex;
    flex-direction: column;
}
.redText{
    color: #f56c6c;
    font-size: 12px;
    line-height: 16px;
}
.greenText{
    color: #31BB6D;
    font-size: 12px;
    line-height: 16px;
}
</style>